import api from "@/services/api";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Thunk to fetch the single record (e.g., passing type = 'terms' or 'privacy')
export const fetchPolicy = createAsyncThunk(
  "policy/fetchPolicy",
  async (type, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/policies/${type}`);
      return response;
      
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to save or update the record
export const savePolicy = createAsyncThunk(
  "policy/savePolicy",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/policies`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const policySlice = createSlice({
  name: "policy",
  initialState: {
    selected: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetStatus: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Policy
      .addCase(fetchPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.selected = action.payload.data;
      })
      .addCase(fetchPolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save Policy
      .addCase(savePolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(savePolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.selected = action.payload.data;
      })
      .addCase(savePolicy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = policySlice.actions;
export default policySlice.reducer;